<template>
  <div>
    <q-btn
      label="Adicionar Executantes"
      color="blue"
      @click="disabled ? $event.stopPropagation() : (incluir = !incluir)"
      no-caps
      flat
      class="btn"
      dense
      icon="add_circle_outline"
      :disable="disabled"
    />

    <div v-if="incluir" class="row q-mt-lg text-brand-5 text-weight-bold">
      <div class="q-pt-none">
        <q-form ref="executanteForm">
          <div class="row col-12 q-gutter-x-sm container-nowrap">
            <div class="col-md-4 col-sm-4 col-xs-4">
              <div class="q-ml-sm titulo-input">Executante</div>
              <q-select
                dense
                outlined
                class="select-btn"
                :rules="[(val) => val || 'Campo Obrigatório']"
                v-model="executante.terceirizado"
                :options="options"
              />
            </div>
            <div
              v-if="!executante.terceirizado.value"
              class="col-md-6 col-sm-6 col-xs-6"
            >
              <select-component
                :unidade="unidade"
                @selectValue="injectFuncionario"
                :label="'Nome do Executante'"
              />
            </div>

            <div v-if="executante.terceirizado.value">
              <select-component-parceiros
                @selectValue="injectParceiro"
                :label="'Nome Empresa Parceira'"
                :unidadeId="unidade"
              />
            </div>
            <div v-if="executante.terceirizado.value">
              <select-component-terceiros
                @selectValue="injectTerceiro"
                :unidade="unidade"
                :parceiro="parceiro"
                :label="'Nome Colaborador Terceiro'"
              />
            </div>
            <div class="col-md-3">
              <p></p>
              <q-btn
                class="q-mt-sm btn-adicionar"
                icon="check_circle_outline"
                label="Confirmar"
                color="positive"
                dense
                no-caps
                :loading="isValidating"
                @click.prevent="adicionarExecutante"
              />
            </div>
          </div>
        </q-form>
      </div>
    </div>

    <StatusEpiModal
      v-model="showEpiDialog"
      :message="epiDialogProps.message"
      :epi-items="epiDialogProps.epiItems"
      :is-blocked="epiDialogProps.isBlocked"
      :has-critical-items="epiDialogProps.hasCriticalItems"
      @confirm="handleEpiDialogConfirm"
      @cancel="handleEpiDialogCancel"
    />
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { inject } from "vue";
import SelectComponent from "./SelectComponent.vue";
import SelectComponentTerceiros from "./SelectComponentTerceiros.vue";
import SelectComponentParceiros from "./SelectComponentParceiros.vue";
import { useEpiValidation } from "@/composables/useEpiValidation.js";
import StatusEpiModal from "@/components/StatusEpiModal.vue";

export default {
  props: ["ptId", "unidade", "disabled"],
  emits: ["closing"],
  components: {
    SelectComponent,
    SelectComponentTerceiros,
    SelectComponentParceiros,
    StatusEpiModal,
  },
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    let parceiro = ref(null);
    let empresaTerceiro = ref(null);
    const incluir = ref(false);
    const executanteForm = ref(null);
    const keycloak = inject("keycloak");

    const { validateUserForInclusion, loading: isValidating } =
      useEpiValidation();
    const showEpiDialog = ref(false);
    const epiDialogProps = ref({});
    const pendingExecution = ref(null);

    const options = ref([
      {
        value: false,
        label: "Não Terceirizado",
      },
      {
        value: true,
        label: "Terceirizado",
      },
    ]);

    let executante = ref({
      terceirizado: {
        value: false,
        label: "Não Terceirizado",
      },
      matricula: "",
      nome: "",
      userId: null,
      cargo: null,
    });

    const injectFuncionario = async (value, funcionarioData) => {
      if (!value) return;

      let data = value.split("-");
      executante.value.matricula = data[1]?.trim() || "";
      executante.value.nome = data[0]?.trim() || "";
      executante.value.cargo = funcionarioData?.cargo || null;

      if (funcionarioData?.userId) {
        executante.value.userId = funcionarioData.userId;
      } else {
        executante.value.userId = null;
      }
    };

    const injectParceiro = async (value) => {
      parceiro.value = value;
      empresaTerceiro.value = value.split(" - ")[2];
    };

    const injectTerceiro = async (value) => {
      executante.value.nome = value.split("-")[0];
      executante.value.matricula = value.split("-")[1];
    };

    const handleEpiDialogConfirm = async () => {
      showEpiDialog.value = false;
      if (pendingExecution.value) {
        await pendingExecution.value();
        pendingExecution.value = null;
      }
    };

    const handleEpiDialogCancel = () => {
      showEpiDialog.value = false;
      pendingExecution.value = null;
    };

    const executeAddExecutante = async () => {
      try {
        if (executante.value.terceirizado.value == true) {
          await store.dispatch("pdt/adicionarExecutantePt", {
            ptId: props.ptId,
            matricula: executante.value.matricula,
            sap: executante.value.sap,
            nome: executante.value.nome,
            empresa: empresaTerceiro.value,
            terceirizado: executante.value.terceirizado.value,
            cargo: executante.value.cargo,
          });
        } else {
          await store.dispatch("pdt/adicionarExecutantePt", {
            ptId: props.ptId,
            matricula: executante.value.matricula,
            sap: executante.value.sap,
            nome: executante.value.nome,
            empresa: keycloak.realm,
            terceirizado: executante.value.terceirizado.value,
            cargo: executante.value.cargo,
          });
        }

        incluir.value = false;
        quasar.notify({
          message: "Executante adicionado a pt",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        emit("closing");
      } catch (error) {
        let message = "Ocorreu um erro ao adicionar executante a pt";
        if (error.response) {
          message = error.response.data.erro.mensagem;
        }
        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarExecutante = async () => {
      const valido = executanteForm.value.validate();
      if (!valido) {
        return;
      }

      if (executante.value.nome == "" || executante.value.matricula == "") {
        return;
      }

      try {
        if (!executante.value.terceirizado.value && executante.value.userId) {
          const validationResult = await validateUserForInclusion(
            executante.value.userId,
            props.unidade,
            executante.value.terceirizado.value
          );

          if (!validationResult.canInclude) {
            epiDialogProps.value = {
              message: validationResult.message,
              epiItems: validationResult.epiData || [],
              isBlocked: true,
              hasCriticalItems: validationResult.hasCriticalItems || false,
            };
            showEpiDialog.value = true;
            return;
          } else if (validationResult.showWarning) {
            epiDialogProps.value = {
              message: validationResult.message,
              epiItems: validationResult.epiData || [],
              isBlocked: false,
              hasCriticalItems: validationResult.hasCriticalItems || false,
            };

            pendingExecution.value = executeAddExecutante;
            showEpiDialog.value = true;
            return;
          }
        } else if (!executante.value.terceirizado.value) {
          console.warn("ATENÇÃO: Executante não terceirizado mas sem userId!");
        }

        await executeAddExecutante();
      } catch (error) {
        await executeAddExecutante();
      }
    };

    return {
      incluir,
      executanteForm,
      executante,
      adicionarExecutante,
      injectFuncionario,
      parceiro,
      empresaTerceiro,
      injectParceiro,
      injectTerceiro,
      options,
      isValidating,
      showEpiDialog,
      epiDialogProps,
      handleEpiDialogConfirm,
      handleEpiDialogCancel,
    };
  },
};
</script>

<style scoped>
.container-nowrap {
  flex-wrap: nowrap;
}
@media (max-width: 1000px) {
  .container-nowrap {
    flex-wrap: wrap;
  }
}
@media (max-width: 600px) {
  .btn {
    font-size: 12px;
  }
  .select-btn {
    font-size: 9px;
  }
  .titulo-input {
    margin: 0px;
    font-size: 11px;
  }
  .btn-adicionar {
    font-size: 11px !important;
  }
  .container-nowrap {
    flex-wrap: wrap;
  }
}
</style>
